import { useNavigate } from "react-router";
import { ErrorBoundary } from "./ErrorBoundary";
import NoDataDpContainer from "../NoDataDp/NoDataDp";
import styles from "./ErrorBoundary.module.scss";

interface Props {
  children: any;
  fallbackContainerClassName?: any;
}

function TechnicalErrorBoundary({
  children,
  fallbackContainerClassName,
}: Props) {
  const navigate = useNavigate();

  return (
    <ErrorBoundary
      fallback={
        <div
          className={
            fallbackContainerClassName ?? styles.technicalErrorBoundary
          }
        >
          <NoDataDpContainer
            title={"Technical Error"}
            subTitle={
              <>
                {`This is due to a technical error with Merito!`}
                <br />
                You can send a support message below or call +919867054499
              </>
            }
            button
            buttonText={"Go to Support"}
            onClick={() => navigate("/support")}
          />
        </div>
      }
    >
      {children}
    </ErrorBoundary>
  );
}

export default TechnicalErrorBoundary;
